import type { ReactNode } from 'react';
import { Search, type LucideIcon } from 'lucide-react';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title?: string;
  message?: string;
  /** Optional call-to-action node rendered under the message. */
  action?: ReactNode;
  className?: string;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

/** Centered "nothing here" placeholder for empty lists and results. */
export function EmptyState({
  icon: Icon = Search,
  title = 'Nothing here yet',
  message = 'Check back later for new content.',
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 py-16 text-center',
        className,
      )}
    >
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
        <Icon size={40} className="text-primary" aria-hidden="true" />
      </div>
      <h3 className="mt-5 text-lg font-bold text-ink">{title}</h3>
      <p className="mt-2 max-w-sm text-center text-sm text-ink-secondary">
        {message}
      </p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
